import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { Card, Label, Link } from 'irmlib/components/Controls'
import { useTheme } from 'irmlib/styles'

const titleFontSize = '20px'
const cardHeight = '458px'
const titleHeight = '49px'
const rowHeight = '44px'

const CardBodyContainer = styled.div`
`

const TitleContainer = styled(Label)`
  background-color: ${props => props.theme.palette.primary.main};
  color: ${props => props.theme.palette.background.default};
  font-size: ${titleFontSize};
  height: ${titleHeight};
  display: flex;
  align-items: center;
  padding-left: 20px;
`

const BodyContainer = styled.div`
  padding: 4px 20px 0px 20px;
`

const CardContainer = styled(Card)`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 4px 4px -2px rgb(102,102,102);
`

const Content = styled.div`
  flex-grow: 1;
`

const TableHeader = styled.td`
  font-weight: bold;
`

export const BaseCard = props => {
  const theme = useTheme()
  return (
    <CardContainer style={{ minHeight: props.height ? props.height : cardHeight }} variant='outlined' id={props.id}>
      <Content>
        <TitleContainer theme={theme} id={`${props.id}-title`}>
          {props.title}
        </TitleContainer>
        <BodyContainer id={`${props.id}-body`}>
          {props.body}
        </BodyContainer>
      </Content>
    </CardContainer>
  )
}

BaseCard.propTypes = {
  title: PropTypes.string,
  body: PropTypes.element,
  id: PropTypes.string.isRequired,
  height: PropTypes.string,
}

export const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
`

const TableHeaderRow = styled.tr`
  height: ${rowHeight};
`

const TableRow = styled.tr`
  height: ${rowHeight};
  border-top: 1px solid rgb(66, 66, 66);
`

const AdditionalTitle = styled.div`
  padding-top: 11px;
`

export const CardBody = props => {
  const theme = useTheme()
  const linkStyle = {
    textDecoration: 'none',
    color: '#1B75BC'
  }
  return (
    <CardBodyContainer>
      {props.additionalTitle && <AdditionalTitle>{props.additionalTitle}</AdditionalTitle>}
      <Table>
        <thead>
          <TableHeaderRow>
            {props.headers.map((e, index) => {
              return (
                <TableHeader key={index} style={e.style}>
                  <Label id={`dashboard-${e.label}`}>
                    {e.label}
                  </Label>
                </TableHeader>
              )
            })}
          </TableHeaderRow>
        </thead>
        <tbody>
          {
            props.data.map((row, rowIndex) => {
              return ( 
                <TableRow key={rowIndex}>
                  {row.map((column, colIndex) => (
                    <td key={colIndex} style={{ textAlign: props.headers[colIndex].style.textAlign }}>
                      {column.label && column.url
                        ? <Link id={`dashboard-${column.label}`} url={column.url} linkStyle={linkStyle} theme={theme} color={colIndex === 0 ? 'default' : 'primary'} noTranslate={colIndex !== 0}>
                          {column.label}
                        </Link>
                        : column.label
                          ? <Label id={`dashboard-${column.label}`} style={{ color: '#58595B' }} noTranslate={colIndex !== 0}>{column.label}</Label>
                          : <Label id={`${row[0].label}-${colIndex}-data`} style={{ color: '#58595B' }} noTranslate>{column}</Label>
                      }
                    </td>
                  ))}
                </TableRow>
              ) 
            })
          }     
        </tbody>
      </Table>
    </CardBodyContainer>
  )
}

CardBody.propTypes = {
  data: PropTypes.array.isRequired,
  headers: PropTypes.arrayOf(PropTypes.shape({
    style: PropTypes.object,
    label: PropTypes.string,
  })).isRequired,
  additionalTitle: PropTypes.node
}